import { Helmet, HelmetData } from "react-helmet-async";
import { useTranslation } from "react-i18next";

const helmetData = new HelmetData({});

type HeadProps = { title: string };

export const Head = (props: HeadProps) => {
  const { title } = props;

  const { t } = useTranslation();
  const { root } = t("features.shared.Head") as unknown as { root: string };

  return (
    <Helmet helmetData={helmetData}>
      <title>{title ? `${title} - ${root}` : root}</title>
    </Helmet>
  );
};
